import events, { EventSubscription } from '../events'
import { RouterEventsLocalCodeChangeCallback, RouterEventType } from './types'

const routerEventsNamespace: string = 'router.'

const routerChangeEvent = "".concat(routerEventsNamespace, "change");

export const CHANGE_LOCALE_CODE_EVENT = 'localeCodeChange'

const routerEvents = {
    onLocalCodeChange(callback: RouterEventsLocalCodeChangeCallback): EventSubscription {
        return events.subscribe(routerEventsNamespace + CHANGE_LOCALE_CODE_EVENT, callback)
    },

    trigger(eventName: RouterEventType, ...args: any[]): void {
        events.trigger(routerEventsNamespace + eventName, ...args)
    },

    onChange(callback: any) {
        return events.subscribe(routerChangeEvent, callback)
    }
}


export default routerEvents
